import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8dc1fa72")

_pushScopeId("data-v-8dc1fa72")
const _hoisted_1 = { class: "txt txt txt-medium name" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Imgix = _resolveComponent("Imgix")

  return (_openBlock(), _createBlock("a", {
    class: "office-talent-list-card l-office-talent-list",
    href: _ctx.state.url,
    target: "_blank"
  }, [
    _createVNode(_component_Imgix, {
      class: "l-office-talent-image",
      imageUrl: _ctx.imageSrc,
      imageSize: _ctx.imageSize
    }, null, 8, ["imageUrl", "imageSize"]),
    _createVNode("p", _hoisted_1, _toDisplayString(_ctx.displayName), 1)
  ], 8, ["href"]))
})